export default {"src":"/_next/static/media/browsers.f71df393.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};